<template>
  <div class="uninstall__container d-flex flex-column">
    <div class="uninstall__header" :class="{ 'uninstall__header-survey': activeView === 'survey' }">
      <div class="uninstall__header-left d-flex">
        <GpTabs class="uninstall__tabs-container" @tabChange="onTabChangeHandler" :customNav="true" :active.sync="activeView">
          <template #GpTabsNav="{activeIndex, handler}">
            <GpTabsNav class="uninstall__tabs-nav">
              <GpTab class="uninstall__tab" :class="{ 'ml-1 ml-md-5': index != 0 }" :index="tab.key" :activeIndex="activeIndex || 'survey'" :disabled="disabledTab(tab.key)" @click="handler" v-for="(tab, index) in tabs" :key="'tab_' + tab.key">
                <p class="typo-button14 typo-medium nowrap">{{ `${index + 1}. ${tab.text}` }}</p>
              </GpTab>
            </GpTabsNav>
          </template>
        </GpTabs>
      </div>
    </div>
    <div class="uninstall__body">
      <transition name="slide-fade">
        <UninstallSurvey v-if="activeView === 'survey'" @goToConfirm="onTabChangeHandler('confirm')" />
        <div v-if="isGemPagesV6">
          <UninstallCautions v-if="activeView === 'confirm'" @continue="onTabChangeHandler('code-management')" />
          <UninstallCodeManagement v-if="activeView === 'code-management'" />
        </div>
        <UninstallConfirmation v-else-if="activeView === 'confirm'" />
      </transition>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import GpTabs, { GpTab, GpTabsNav } from "@/core/shared/GpTabs";
import UninstallSurvey from "./UninstallSurvey.vue";
import UninstallCodeManagement from "./UninstallCodeManagement.vue";
import UninstallCautions from "./UninstallCautions.vue";
import UninstallConfirmation from "./UninstallConfirmation.vue";

export default {
  name: "Uninstall",
  components: {
    GpTabs,
    GpTab,
    GpTabsNav,
    UninstallSurvey,
    UninstallCodeManagement,
    UninstallCautions,
    UninstallConfirmation
  },
  data() {
    return {
      activeView: "survey",
      activatedTabs: ["survey"]
    };
  },
  computed: {
    ...mapState({
      shopInfo: state => state.account.shopInfo
    }),
    tabs() {
      const tabItems = [
        {
          text: this.$t("uninstall.tab.title.uninstallReason"),
          key: "survey"
        },
        {
          text: this.$t("uninstall.tab.title.uninstallConfirmation"),
          key: "confirm"
        }
      ];

      if (this.isGemPagesV6) {
        tabItems.push({
          text: this.$t("uninstall.tab.title.uninstallCodeManagement"),
          key: "code-management"
        });
      }

      return tabItems;
    },
    isGemPagesV6() {
      return this.shopInfo?.shopType?.isGemPagesV6;
    }
  },
  methods: {
    ...mapActions("account", {
      whoAmI: "accountWhoAmI"
    }),
    disabledTab(targetTab) {
      return !this.activatedTabs.includes(targetTab);
    },
    onTabChangeHandler(tab) {
      this.activeView = tab;
      this.activatedTabs.push(tab);
    },
    exitUninstall() {
      this.$router.replace({ name: "AccountSettings" });
    }
  }
};
</script>

<style scoped lang="scss">
.slide-fade-enter-active {
  transition: all 0.5s ease;
}
.slide-fade-enter,
.slide-fade-leave-to {
  opacity: 0;
  transform: translateX(100px);
}
.uninstall {
  &__header {
    display: grid;
    grid-template-columns: 680px 520px;
    gap: 24px;
    justify-content: center;
    position: relative;

    &-left {
      height: 100%;
    }
    &-back-icon-wrapper {
      height: 16px;
      width: 16px;
      @include flex-center;
    }
    &-left__back-action-btn {
      color: $dark6;
      font-weight: 500;
      line-height: 16px;
      &:hover {
        color: $textLightModeHigh;
        .icon {
          color: $textLightModeHigh;
        }
      }
    }
    width: 100%;
    height: 60px;

    &-cancel {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  &__body {
    overflow: auto;
    height: 100%;
  }
  &__container {
    margin-top: 40px;
    background-color: white;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-attachment: local;
    display: flex;
    z-index: 50;
  }
}

@media only screen and (max-width: 1360px) {
  .uninstall__header {
    grid-template-columns: auto;
    padding-left: 80px;
    justify-content: start;
  }
}
</style>
